import axios from '@util/axios';

class Members {
  async getMembers(params = {}, companyId = null) {
    let url = '/member/';

    if (companyId) url += `by_company/${companyId}/`;

    return await axios({
      url: url,
      params: {
        page: params.page || null,
        page_size: params.page_size || null,
        report_id: params.report_id || null,
        assigned: params.assigned || null,
        type: params.type || null,
      },
    });
  }

  async createMember(formData, isSuperuser = false) {
    return await axios({
      url: `/member/`,
      method: 'POST',
      data: {
        email: formData.email,
        display_name: formData.display_name,
        company: formData.company || null,
        type: formData.type || null,
        status: formData.status,
        billing_contact: formData.billing_contact || "InActive",
      },
      ...(isSuperuser
        ? {
            params: { create_superuser: true },
          }
        : null),
    });
  }

  async readMember(id) {
    return await axios({
      url: `/member/${id}`,
    });
  }

  async updateMember(id, formData) {
    return await axios({
      url: `/member/${id}/`,
      method: 'PUT',
      data: {
        display_name: formData.display_name,
        company: formData.company || null,
        type: formData.type || null,
        status: formData.status,
      },
    });
  }

  async toggleMemberStatus(id, status = true) {
    return await axios({
      url: `/member/change/status/${id}/`,
      method: 'POST',
      data: {
        status: status ? 'Active' : 'InActive',
      },
    });
  }

  async toggleCashCallApproverMemberStatus(id, status = true) {
    return await axios({
      url: `/member/change/cash-call-approver/status/${id}/`,
      method: 'POST',
      data: {
        cash_call_approver: status ? 'Active' : 'InActive',
      },
    });
  }

  async toggleBillingContactStatus(id, status = true) {
    return await axios({
      url: `/member/change/billing-contact/status/${id}/`,
       method: 'POST',
       data: {
         billing_contact: status ? 'Active' : 'InActive',
       },
     });
  }

  async toggleRecStatus(id, status = true) {
    return await axios({
      url: `/member/change/rec/status/${id}/`,
      method: 'POST',
      data: {
        user_rec_status: status ? 'Active' : 'InActive',
      },
    });
  }

  async getDefaultReport(userId) {
    return await axios({
      url: `/set/default/report/${userId}/`,
    });
  }

  async setDefaultReport(userId, reportId) {
    return await axios({
      url: `/set/default/report/${userId}/`,
      method: 'PUT',
      data: {
        default_report: reportId,
      },
    });
  }
}

export default new Members();
